var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "block_inp p-3" }, [
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "advanced_name" } },
        [_vm._v("\n\t\t\tНазва\n\t\t")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-group flex-nowrap" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.question.name,
              expression: "question.name",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "advanced_name", type: "text" },
          domProps: { value: _vm.question.name },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.question, "name", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-4" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v("\n\t\t\tПривязка Uprox\n\t\t"),
      ]),
      _vm._v(" "),
      _vm.doors.length > 0
        ? _c(
            "div",
            {},
            [
              _c(
                "v-select",
                {
                  staticClass: "imc_reasons",
                  attrs: {
                    reduce: (active_type) => active_type.token,
                    label: "name",
                    options: this.doors,
                    filterable: false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(option.name) +
                                  "\n\t\t\t\t\t\t"
                              ),
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(option.group_name) +
                                      "\n\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2199515025
                  ),
                  model: {
                    value: _vm.active_type,
                    callback: function ($$v) {
                      _vm.active_type = $$v
                    },
                    expression: "active_type",
                  },
                },
                [
                  _c("template", { slot: "no-options" }, [
                    _vm._v("\n\t\t\t\t\tОберіть Тип(и)\n\t\t\t\t"),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-4" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v("\n\t\t\tОрганізація\n\t\t"),
      ]),
      _vm._v(" "),
      _vm.tovs.length > 0
        ? _c(
            "div",
            {},
            [
              _c(
                "v-select",
                {
                  staticClass: "imc_reasons",
                  attrs: {
                    reduce: (active_tov) => active_tov.id,
                    label: "small_title",
                    options: this.tovs,
                    filterable: false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(option.small_title) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2297331345
                  ),
                  model: {
                    value: _vm.active_tov,
                    callback: function ($$v) {
                      _vm.active_tov = $$v
                    },
                    expression: "active_tov",
                  },
                },
                [
                  _c("template", { slot: "no-options" }, [
                    _vm._v("\n\t\t\t\t\tОберіть Тип(и)\n\t\t\t\t"),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", { staticClass: "form-label" }, [
          _vm._v("\n\t\t\tTelegram Groups\n\t\t"),
        ]),
        _vm._v(" "),
        _c("v-select", {
          staticClass: "imc_reasons",
          attrs: { taggable: "", multiple: "" },
          model: {
            value: _vm.question.bot_groups,
            callback: function ($$v) {
              _vm.$set(_vm.question, "bot_groups", $$v)
            },
            expression: "question.bot_groups",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }